import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const PagesList = () => {
  return <SingleContentPage title="CMS Pages" moduleKey="cms-pages" />;
};

export default PagesList;
